import React from "react";

const Privacy = (props) => {

    return (
        <div>
            {/*id="about-me-heading-mobile"*/}
<div className="section">
    
<div className="text-box" >
  <h1 className="text-center text-wrap w-75 m-auto mt-0">Privacy Statement
  </h1>
</div>

<div className="m-auto mt-5" id="privacy">
  <div className="text-start">
  {/*<div className=" w-60 text-box d-flex align-items-start flex-column mt-5">*/}
    
  <p>
      I value your trust and respect your privacy.  The statement below explains how I look after your personal 
      data and is based on guidance from the Information Commissioner’s Office. You can find more about the ICO 
      here: <a href="https://ico.org.uk/">https://ico.org.uk/</a>
  </p>
  <p>
      <strong>Who am I? (The Data Controller)</strong>
      
  </p>
  <div id="address">
      <p>Tamsin Husband</p>
      <p>thsciencetutor@gmail.com </p>
      
  </div>
  
  <p>
      <strong>3rd Party Links</strong>
      <strong></strong>
  </p>
  <p>
      This website may include links to third-party websites. Clicking on those
      links or enabling those connections may allow third-parties to collect or
      share data about you - I do not control these third websites and are not
      responsible for their privacy statements. When you leave my website, I
      encourage you to read their individual privacy notes.
  </p>
  <p>
      <strong><u></u></strong>
  </p>
  <p>
      <strong>What data do I collect?</strong>
      <strong></strong>
  </p>
  <p>
      To enable me to conduct my business operations as well as facilitate
      logistics and carry out accounting processes, I will, when necessary,
      collect, use, store and transfer personal information which may include:
  </p>
  <p>
      <em>Identity Data:</em> First Name, Last Name of bill paper; first name, last name of tutee(s)
  </p>
  <p>
      <em>Contact Data:</em> Billing address, Delivery address, Email address, Telephone
      numbers
  </p>
  <p>
      <em>Technical Data:</em> session statistics including approximate geolocation 
      (see Google Analytics entry in Third Party Businesses section below)
  </p>
  <p>
      <em>Financial Data:</em> Payment details including bank account number and sort code.
  </p>
  <p>
      <em>Tutee Notes:</em> The school / college attended by tutee; notes that are made during class, 
      notes pertaining to the tutee's performance, recent test papers carried out by the tutee with third 
      parties (ie: at school / college / other eduational institutes).
  </p>
  
  <p>
      <strong>How I collect your data:</strong>
      <strong></strong>
  </p>
  <p>
      I will collect your Data from you directly in the following ways:
  </p>
  <div className="mb-3">
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/burnt-orange-test-tube.png"></img>
      </div>
      When you communicate with me via email or speak to me in person or on the phone, especially in connection with organizing workshops.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/orange-test-tube.png"></img>
      </div>
      When you contact me via my social media channels.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/pink-test-tube.png"></img>
      </div>
      I collect personal markers such as name, address, email address or phone number via this website. By entering those details
        and clicking the button to submit, you consent to share those details.
    </li>    
  </div>
  
  
  <p>
      <strong>Failure to provide personal data</strong>
      <strong></strong>
  </p>
  <p>
      If I need to collect your personal data under the terms of a contract I
      have with you and you fail to provide that data when requested, I may not
      be able to perform the contract I have or am trying to enter into with you.
      For example to provide you with goods and services. In this case I may have
      to cancel delivery of a product or service you may have requested from me -
      but I will notify you in this case.
  </p>
  <p>
      <strong>How I use your data (The lawful basis for the processing)</strong>
      <strong></strong>
  </p>
  <p>
      <em>Performance of contract</em>
      <u></u>
  </p>
  <p>
      In store / by email / by social media / by phone.
  </p>
  <p>
      This means processing your data where it is necessary for the performance
      of a contract to which you are a party, or to take steps at your request
      before entering into such a contract. For example, to communicate with you,
      to facilitate logistics and to provide payment to or to receive payment
      from you.
  </p>
  <p>
      <em>Legitimate interest</em>
      <u></u>
  </p>
  <p>
      Via my website - To monitor and improve the quality of my website platform.
  </p>
  <p>
      This means the interest of my business in conducting and managing my
      business to enable me to give you the best possible service / product and
      the most secure experience. I make sure I consider and balance any
      potential impact on you and your rights before I process your personal data
      for my legitimate interest. I will not use your personal data for
      activities where our interests are overridden by the impact on you (unless
      we have your consent or are otherwise permitted to by law)
  </p>
  <p>
      I would also use your data when you have given me your consent. This means
      you have opted to receive emails by contacting me directly with an enquiry.
  </p>
  <p>
      <strong id="cookies-statement">Cookies</strong>
      
  </p>
  <p>
      My website uses cookies to distinguish you from other users of my website. These cookies are used to collect information 
      to analyse the traffic to our website and how visitors are using our website. For example, these cookies may track things 
      such as how long you spend on the website or the pages you visit which helps us to understand how we can improve our website 
      for you. The information collected through these tracking and performance cookies do not identify any individual visitor. 
      When arriving on my site you will be asked to agree to this use of cookies and so by continuing to browse the site, you are 
      agreeing to the use of cookies.
  </p>
  <p>
      <strong>Who I share your data with</strong>
      <strong></strong>
  </p>
  <p>
      I may be required to provide your Personal Data to a third party who is
      classed as Data Processor. This is an entity that is required to process
      some or all of your Personal Data in order for us to be able to provide our
      services. These include:
  </p>
  <div className="mb-3">
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/burnt-orange-test-tube.png"></img>
      </div>
      Internal third parties, such as contractors or freelances engaged by me to enable me to complete work upon a project.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/orange-test-tube.png"></img>
      </div>
      Professional advisers acting as processors, including my accountant.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/pink-test-tube.png"></img>
      </div>
      HM revenue and customs, regulators and other authorities acting as processors based in the UK who may require reporting of processing activities in certain circumstances.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/red-test-tube.png"></img>
      </div>
      Business tools that I might use to run my business in which case they act as the Data controller (listed in the next section)
    </li>
  </div>
  
  
  <p>
      While the information you provide may be disclosed to these companies, it
      will only be used for the provision and administration of the service
      provided and will not be used for any other purpose. We will never share
      your information for any direct marketing of additional services, products
      etc.
  </p>
  <p>
      If we provide information to a third party, we will require it and any of
      its agents and/or suppliers to take all steps reasonably necessary to
      ensure that your data is treated securely and by this Privacy Statement and
      the DPA 2018.
  </p>
  <p>
      We may of course be obliged by law to pass on your information to the
      police or other law enforcement body.
  </p>
  <p>
      We may also share your information with anyone you have authorised to deal
      with us on your behalf.
      <br/>
      <br/>
  </p>
  <p>
      <strong>3rd Party business tools I use to process your data</strong>
      
  </p>
  <div >
  <p><em>
      Google Analytics
  </em>
  </p>
  <div className="mb-3">
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/burnt-orange-test-tube.png"></img>
      </div>
      <p className="fs-5 mb-0">Google Analytics version 4 records: Number of users, Session statistics, Approximate geolocation, 
          Browser and device information. More information is available <a target="_blank" href="https://support.google.com/analytics/answer/11593727?hl=en">here</a>.</p>
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/orange-test-tube.png"></img>
      </div>
      <p className="fs-5 mb-0">Note, this website uses Google Analytics version 4, 
          which does not collect IP addresses. More information is available <a target="_blank" href="https://support.google.com/analytics/answer/12017362?hl=en#:~:text=Analytics%20does%20not%20log%20IP,or%20store%20individual%20IP%20addresses."> here</a>.</p>
    </li>
    
  </div>
  
  <p><em>
      Gmail
  </em>
  </p>
  <div className="mb-3">
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/pink-test-tube.png"></img>
      </div>
      To answer your enquiries
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/red-test-tube.png"></img>
      </div>
      They collect: Name, email address
    </li>
    
  </div>
  
  <p><em>
      Instagram
  </em>
  </p>
  <div className="mb-3">
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/burnt-orange-test-tube.png"></img>
      </div>
      To answer your enquiries via the messenger section of the app
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/orange-test-tube.png"></img>
      </div>
      They collect: Name, email address
    </li>
    
  </div>
  
  
  <p><em>
      Facebook
  </em>
  </p>
  <div className="mb-3">
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/pink-test-tube.png"></img>
      </div>
      To answer your enquiries via the messenger section of my page
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/red-test-tube.png"></img>
      </div>
      They collect: Name, email address
    </li>

  </div>
  
  </div>
  <p>
      <strong>Data Security</strong>
      <strong></strong>
  </p>
  <p>
      Your information is securely stored. I have put in place procedures to deal
      with any suspected personal data breach and will notify you and any
      applicable regulator of a breach where I am legally required to do so.
  </p>
  <p>
      Any new information you provide us may be used to update an existing record
      we hold for you.
  </p>
  <p>
      <strong>Data retention</strong>
      <strong></strong>
  </p>
  <p>
      We will not keep your personal information longer than is necessary for the
      purpose for which it was provided unless we are required by law or have
      other legitimate reasons to keep it for longer (for example if necessary
      for any legal proceedings).
  </p>
  <p>
      We will normally keep information for no more than seven years after the
      termination or cancellation of a contract or service we provide.
  </p>
  <p>
      <strong>Your rights</strong>
      
  </p>
  <p>
      Unless subject to an exemption under the data protection laws, you have the
      following rights with respect to your personal data:
  </p>
  <div className="mb-3">
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/burnt-orange-test-tube.png"></img>
      </div>
      The right to request a copy of the personal data which I hold about you
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/orange-test-tube.png"></img>
      </div>
      The right to request that I correct any personal data if it is found to
          be inaccurate or out of date
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/pink-test-tube.png"></img>
      </div>
      The right to request your personal data is erased where it is no longer
          necessary to retain such data
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/red-test-tube.png"></img>
      </div>
      The right to withdraw your consent to the processing at any time, where
          consent was the lawful basis for processing your data.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/burnt-orange-test-tube.png"></img>
      </div>
      The right to request that I provide you with your personal data and where
          possible, to transmit that data directly to another data controller, (known
          as the right to data portability), where applicable i.e. where my
          processing is based on consent or is necessary for the performance of my
          contract with you or where I process your data by automated means.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/orange-test-tube.png"></img>
      </div>
      The right, where there is a dispute in relation to the accuracy or
          processing of your personal data, to request that a restriction is placed
          on further processing of your data.
    </li>
    <li className="d-flex">
      <div className="test-tube-icon-container" >
        <img className="test-tube-icon " alt="" src="../images/test-tube-icons/pink-test-tube.png"></img>
      </div>
      The right to object to my processing of your personal data, where
          applicable i.e. where processing is based on my legitimate interests (or
          in performance of a task in the public interest/exercise of official
          authority), direct marketing or processing for the purposes of
          scientific/historical research and statistics.
    </li>
    
  </div>
  
  
  <p>
      If you wish to exercise any of the rights set out above, please contact me directly via thsciencetutor@gmail.com 
  </p>
  <p>
      <strong>No fee required – with some exceptions</strong>
  </p>
  <p>
      You will not have to pay a fee to access your personal data (or to exercise
      any of the other rights). However, I may charge a reasonable admin fee if
      your request is clearly unfounded, repetitive or excessive. Alternatively,
      I may refuse to comply with your request in these circumstances.
  </p>
  <p>
      <strong>What I may need from you</strong>
  </p>
  <p>
      I may need to request specific information from you to help me confirm your
      identity and ensure your right to access your personal data (or to exercise
      any of your other rights). This is a security measure to ensure that
      personal data is not disclosed to any person who has no right to receive
      it. I may also contact you to ask you for further information in relation
      to your request to speed up my response to you.
  </p>
  <p>
     <strong> Time limit to respond</strong>
  </p>
  <p>
      I will try to respond to all legitimate requests within one month.
      Occasionally it may take me longer than a month if your request is
      particularly complex or you have made a number of requests of me. In this
      case, I will notify you and keep you updated on my progress.
  </p>
  <p>
      <strong>
          Changes to this notice and your duty to inform us of changes
      </strong>
      
  </p>
  <p>
      This version was last updated on 8th August 2023.
  </p>
  <p>
      Please keep me informed if your personal data changes while we are in association. 
      It is important that the personal data I hold about you is accurate and also current.
  </p>
  <p>
      <strong>Queries, requests or concerns</strong>
      
  </p>
  <p>
      To exercise all relevant rights, queries or complaints in relation to this policy or any other data 
      protection matter between you and myself, Tamsin Husband, please in the first instance contact me on 
      thsciencetutor@gmail.com
  </p>
  <p>
      If this does not resolve your complaint to your satisfaction, you have the
      right to lodge a complaint with the
      <a href="https://ico.org.uk/global/contact-us/">
          Information Commissioners Office
      </a>
      on 03031231113 or via email
      <a href="https://ico.org.uk/global/contact-us/email/">
          https://ico.org.uk/global/contact-us/email/
      </a>
      or at the Information Commissioner’s Office, Wycliffe House, Water Lane,
      Wilmslow, Cheshire, SK9 5AF, England, UK.
  </p>
  </div>
  </div>
  </div>
</div>

       

    )
}

export default Privacy;